import { useAuthenticator } from "@aws-amplify/ui-react";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { Container } from "@mui/material";
import Home from "./pages/Home";
import Detail from "./pages/Detail";
import MintMedal from "./pages/MintMedal";
import EditThreshold from "./pages/EditThreshold";
import Header from "./components/Header";
import CustomAuthenticator from "./components/CustomAuthenticator";

function App() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  return (
    <>
      <Container disableGutters maxWidth="false">
        <BrowserRouter basename="/">
          {/* <ScrollToTop /> */}
          <Header />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  {authStatus !== "authenticated" ? (
                    <CustomAuthenticator />
                  ) : (
                    <Home />
                  )}
                </>
              }
            />
            <Route
              path="detail/:walletAddress"
              element={
                <>
                  {authStatus !== "authenticated" ? (
                    <CustomAuthenticator />
                  ) : (
                    <Detail />
                  )}
                </>
              }
            />
            <Route
              path="medal/:walletAddress"
              element={
                <>
                  {authStatus !== "authenticated" ? (
                    <CustomAuthenticator />
                  ) : (
                    <MintMedal />
                  )}
                </>
              }
            />
            <Route
              path="threshold/edit"
              element={
                <>
                  {authStatus !== "authenticated" ? (
                    <CustomAuthenticator />
                  ) : (
                    <EditThreshold />
                  )}
                </>
              }
            />
          </Routes>
          {/* <Footer /> */}
        </BrowserRouter>
      </Container>
    </>
  );
}

export default App;
